import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import './Auth.css';

import { API_BASE } from '../config/api';
import { jsonHeaders, loginUser, parseApiError } from '../utils/apiClient';

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({ 
    firstName: '',
    lastName: '',
    email: '', 
    password: '',
    phone: ''
  });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isLogin) {
        const loginResult = await loginUser(formData.email, formData.password);
        if (!loginResult.ok) {
          if (loginResult.error.toLowerCase().includes('verify')) {
            alert('Please verify your email before logging in.');
            navigate(`/verify-email?email=${encodeURIComponent(formData.email.trim())}`);
          } else {
            alert(loginResult.error || 'Invalid credentials');
          }
          return;
        }
        login(loginResult.user, loginResult.token);
        navigate('/dashboard');
      } else {
        const response = await fetch(`${API_BASE}/users/register`, {
          method: 'POST',
          headers: jsonHeaders,
          body: JSON.stringify({
            ...formData,
            email: formData.email.trim(),
          })
        });

        if (response.ok) {
          alert('Registration successful! Please verify your email.');
          navigate(`/verify-email?email=${encodeURIComponent(formData.email.trim())}`);
        } else {
          alert(await parseApiError(response));
        }
      }
    } catch (error) {
      alert(isLogin ? 'Login failed' : 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <Navigation />
      <div className="auth-container">
        <form onSubmit={handleSubmit} className="auth-form">
        <h2>{isLogin ? 'Login' : 'Register'}</h2>
        
        {!isLogin && (
          <>
            <input
              type="text"
              placeholder="First Name"
              value={formData.firstName}
              onChange={(e) => setFormData({...formData, firstName: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={(e) => setFormData({...formData, lastName: e.target.value})}
              required
            />
          </>
        )}
        
        <input
          type="email"
          placeholder="Email"
          value={formData.email}
          onChange={(e) => setFormData({...formData, email: e.target.value})}
          required
        />
        
        <input
          type="password"
          placeholder="Password"
          value={formData.password}
          onChange={(e) => setFormData({...formData, password: e.target.value})}
          required
        />
        
        {!isLogin && (
          <input
            type="tel"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={(e) => setFormData({...formData, phone: e.target.value})}
          />
        )}
        
        <button type="submit" disabled={loading}>
          {loading ? (isLogin ? 'Logging in...' : 'Registering...') : (isLogin ? 'Login' : 'Register')}
        </button>
        
        <p className="auth-toggle">
          <a href="/forgot-password" className="toggle-link">
            Forgot Password?
          </a>
        </p>
        
        <p className="auth-toggle">
          Don't have an account? 
          <a href="/register" className="toggle-link">
            Register here
          </a>
        </p>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default Login;